<template>
    <div
            style="display: inline-flex; overflow-x: hidden; overflow-y: hidden"
            :style="marginStyles"
            class="d-flex align-center"
    >
      <v-icon
          v-if="useIcon"
          v-bind="$attrs"
      >
        {{iconValue}}
      </v-icon>
        <v-progress-circular v-else-if="loading" :size="size" :width="2" color="white"></v-progress-circular>
        <template v-else-if="!useIcon">
            <img
                    v-if="!useIcon"
                    :src="icons.get(match)"
                    alt="ico"
                    :height="size"
                    :width="size"
                    @error="() => handleImgError()"
            />
<!--            @error="$event.preventDefault(); useIcon = true"-->
        </template>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {getServerAddress} from "@/core/request"
import {isValidUrl} from "@/core/codeFunctions";

export default {
    props: {
        match: {
            type: String,
            required: true
        },
        siteId: String
    },
    data() {
        return {
            serverAddr: getServerAddress(),
            useIcon: false,
            isValidUrl: isValidUrl,
            con: console,
            loading: false,
          forceURL: false,
        }
    },
    mounted() {
        this.getIcon()
    },
    methods: {
        ...mapActions(['addIcon']),
      handleImgError() {
        if (!this.useIcon) {
          console.log('err')
          this.useIcon = true;
        }
      },
        getIcon() {
          console.log('GET ICON')
          this.loading = true
          
          if (this.icons.has(this.match))
            return this.loading = false
          
          
          if (!this.client) {
          this.$newReqDownloadFile('GET', `icons/${this.siteId || this.site._id}/${this.match}`, null, null, false, false, null, true)
              .then(data => {
                  if (data.data.size > 2) {
                      const url = window.URL.createObjectURL(new Blob([data.data]));
                      this.addIcon({match: this.match, icon: url})
                  } else {
                    this.useIcon = true
                    console.log('force icon changed')
                  }
              })
              .catch(e => {
                  console.log(e)
                  console.log('eeeeee')
                  this.useIcon = true
              })
              .finally(() => {
                  this.loading = false
              })
        } else {
                console.log("here")
            }
        }
    },
    computed: {
        ...mapGetters(['site', 'icons']),
        iconSrc() {
            return this.icons.has(this.match) ? this.icons.get(this.match) : null
        },
        iconValue() {
          if (this.isValidUrl(this.match)) return 'mdi-web'
          if (this.match === 'Voice Call') return 'mdi-phone'
          if (this.match === 'Teams Meeting') return 'mdi-microsoft-teams'
          if (this.match === 'Teams Call') return 'mdi-microsoft-teams'
          return 'mdi-application'
        },
        marginStyles() {
            return !this.useIcon ? `${typeof this.$attrs.left !== 'undefined' && (this.$attrs.left === '' || !!this.$attrs.left) ? 'margin-right: 8px !important;' : ''}${typeof this.$attrs.right !== 'undefined' && (this.$attrs.right === '' || !!this.$attrs.right) ? 'margin-left: 8px !important;' : ''}` : {}
        },
        size() {
            if (typeof this.$attrs['x-small'] !== "undefined" && (this.$attrs['x-small'] === '' || !!this.$attrs['x-small']))
                return 12
            if (typeof this.$attrs['small'] !== "undefined" && (this.$attrs['small'] === '' || !!this.$attrs['small']))
                return 16
            if (typeof this.$attrs['large'] !== "undefined" && (this.$attrs['large'] === '' || !!this.$attrs['large']))
                return 36
            if (typeof this.$attrs['x-large'] !== "undefined" && (this.$attrs['x-large'] === '' || !!this.$attrs['x-large']))
                return 40
            return 24
        },
    },
}
</script>

<style scoped>

</style>